import React from 'react';
import styled from 'styled-components';
import { Typography, StatusChipType, statusChipColors, Tooltip } from '@utmost.co/utmost-design-system';
import { FieldPermission } from '../../forms';
import { PermissionIcon } from './PermissionIcon';

interface PermissionChipProps {
  permission?: FieldPermission;
  type: StatusChipType;
  text: string;
  permissionKey: 'READ' | 'WRITE';
}

export const PermissionChip = ({ type, text, permission, permissionKey }: PermissionChipProps) => {
  const getTitle = (permissionKey: 'READ' | 'WRITE', permission?: FieldPermission): string => {
    if (permissionKey === 'READ') {
      return `Read (${permission?.READ === true ? 'Permit' : permission?.READ === false ? 'Deny' : 'Undefined'})`;
    }
    return `Update (${permission?.WRITE === true ? 'Permit' : permission?.WRITE === false ? 'Deny' : 'Undefined'})`;
  };

  return (
    <StyledTooltip dark title={getTitle(permissionKey, permission)}>
      <ChipContainer $type={!!permission?.PERMISSION_NAME ? type : StatusChipType.GREY}>
        <StatusReadContainer>
          <PermissionIcon permission={permission} type={permissionKey} />
          <Typography dataTest="permission-text" variant="label1">
            {text}
          </Typography>
        </StatusReadContainer>
      </ChipContainer>
    </StyledTooltip>
  );
};

const ChipContainer = styled.div<{ $type?: StatusChipType }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 8px;
  border-radius: 10px;
  min-width: 49px;
  background: ${({ $type }) => statusChipColors[$type ?? StatusChipType.GREY].backgroundColor};
  gap: 8px;
  cursor: default;

  && {
    color: ${({ $type }) => statusChipColors[$type ?? StatusChipType.GREY].color};
  }
`;

const StatusReadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StyledTooltip = styled(Tooltip)`
  && {
    background-color: ${({ theme }) => theme.colorOnSurface};
    margin-bottom: 4px;
  }
`;
